import * as firebase from 'firebase/app';

const firebaseConfig = {
  apiKey: "AIzaSyCyQdgDot-zkA9Fz-Z_hos3h-DtinankZc",
  authDomain: "shani-project.firebaseapp.com",
  databaseURL: "https://shani-project.firebaseio.com",
  projectId: "shani-project",
  storageBucket: "shani-project.appspot.com",
  messagingSenderId: "953882825185",
  appId: "1:953882825185:web:c1345878a23336bac742a0",
  measurementId: "G-T8VFN2SKDW"
};

firebase.initializeApp(firebaseConfig);

export default {
}